import { QueueItem } from 'hooks/usePlayer'

import { Storages } from './enum'

export class LocalStorage {
  get token() {
    return window.localStorage.getItem(Storages.TOKEN)
  }
  set token(token: string | null) {
    if (token === null) {
      window.localStorage.removeItem(Storages.TOKEN)
    } else {
      window.localStorage.setItem(Storages.TOKEN, token)
    }
  }

  get queue() {
    const value = window.localStorage.getItem(Storages.QUEUE)

    return value ? JSON.parse(value) : null
  }
  set queue(queue: QueueItem[] | null | undefined) {
    if (!queue) {
      window.localStorage.removeItem(Storages.QUEUE)
    } else {
      window.localStorage.setItem(Storages.QUEUE, JSON.stringify(queue))
    }
  }
}

export default new LocalStorage()
